import { Outlet, createFileRoute, notFound } from '@tanstack/react-router'

import { BillingProvider } from '#features/billing/providers/billing-provider'
import { FeatureFlagWorkspaceContext } from '#features/common/components/feature-flag-workspace-context'
import { WorkspaceNotFound } from '#features/workspaces/workspace.not-found'

export const Route = createFileRoute('/_app/$workspace')({
  beforeLoad: ({ params }) => {
    const slug = params?.workspace
    if (slug === undefined || slug.length === 0) {
      throw notFound()
    }
    return { workspaceSlug: slug }
  },
  notFoundComponent: WorkspaceNotFound,
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <BillingProvider>
      <FeatureFlagWorkspaceContext />
      <Outlet />
    </BillingProvider>
  )
}
